import styled from 'styled-components';
import { SHIPMENT_CARD_MARGIN_BOTTOM } from '@/modules/pmt/constants';
import { PMTAdsense } from '@/modules/pmt/components/PMTAdsense';

export const CustomAdsense = styled(PMTAdsense)(({ theme }) => ({
  display: 'flex',
  borderTop: 'none',
  marginTop: theme.spacing[SHIPMENT_CARD_MARGIN_BOTTOM],
  marginBottom: theme.spacing[8],
}));

export const CustomSquareAdsense = styled(PMTAdsense)({
  width: 336,
  height: 345,
  margin: '0 auto',
  padding: 0,
});

export const ShipmentWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});
